export const excludeExternalEmailSubject = (subject = '') => {
  const regex = /(\[EXTERNAL EMAIL\])/g;
  return subject.replace(regex, '').trim();
};

export const mapInboxData = (data) => {
  return data.map(
    ({
      Body,
      MessageType,
      InternalEntityId,
      PlatformMessageId,
      ConversationId,
      DateCreated,
      DeliveredTimestamp,
      ExternalAddress,
      ExternalEntityName,
      Subject,
      Direction,
      unReadCount,
      VanityName,
      Attachments,
    }) => ({
      lastMessageBody: Body,
      lastMessageType: MessageType,
      internalEntityId: InternalEntityId,
      platformMessageId: PlatformMessageId,
      conversationId: ConversationId,
      dateCreated: DateCreated,
      deliveredTimestamp: DeliveredTimestamp,
      externalAddress: ExternalAddress,
      externalEntityName: ExternalEntityName,
      subject: Subject && excludeExternalEmailSubject(Subject),
      direction: Direction,
      unreadMessagesCount: unReadCount,
      vanityName: VanityName,
      hasAttachments: Attachments?.length > 0,
    }),
  );
};
